import React from 'react';
import { Activity, Inbox, Cpu, History, AlertTriangle, CheckCircle2 } from 'lucide-react';

const fmt = (iso) => (iso ? new Date(iso).toLocaleString() : '—');

const Tile = ({ icon: Icon, title, children, onClick, testId, tone = 'text-cyan-400' }) => (
  <button type="button" onClick={onClick} className="text-left bg-slate-800/60 border border-slate-700/50 rounded-xl p-4 hover:border-slate-500 transition-colors" data-testid={testId}>
    <div className="flex items-center gap-2 mb-2"><Icon size={16} className={tone} /><span className="text-sm font-semibold text-white">{title}</span></div>
    <div className="text-xs text-slate-400 space-y-1">{children}</div>
  </button>
);

const AdminOverview = ({ data, onNavigate }) => {
  const po = data.pick_outcomes || {};
  const last = po.last_job;
  const models = data.ai_models?.models || [];
  const available = models.filter((m) => m.available === true).length;
  const probed = models.filter((m) => m.available !== null).length;
  const jobOk = last && last.status === 'succeeded';
  return (
    <div className="space-y-4" data-testid="admin-overview">
      <p className="text-xs text-slate-500">Operational status as of {fmt(data.generated_at)}. No keys, tokens or secrets are shown here.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <Tile icon={Activity} title="API Monitor" onClick={() => onNavigate('metrics')} testId="overview-tile-metrics">
          <p>{data.api.total_requests.toLocaleString()} requests · {data.api.total_errors} errors ({data.api.error_rate_pct}%)</p>
          <p>{data.api.tracked_endpoints} endpoints tracked since {fmt(data.api.uptime_since)}</p>
        </Tile>
        <Tile icon={Inbox} title="Contact Messages" onClick={() => onNavigate('messages')} testId="overview-tile-messages" tone="text-amber-400">
          <p><span className="text-white font-semibold">{data.contact.unhandled}</span> unhandled of {data.contact.total} total</p>
        </Tile>
        <Tile icon={Cpu} title="AI Model Health" onClick={() => onNavigate('models')} testId="overview-tile-models" tone="text-indigo-400">
          <p>{available} of {probed} probed models available · default: <span className="font-mono text-slate-300">{data.ai_models.default}</span></p>
          <p>Last probe: {fmt(data.ai_models.checked_at)}{!data.ai_models.checked_at && ' (not probed since restart)'}</p>
        </Tile>
        <Tile icon={History} title="Daily Pick Outcome Job" onClick={() => onNavigate('outcomes')} testId="overview-tile-outcomes" tone="text-emerald-400">
          <p className="flex items-center gap-1.5">
            {last ? (jobOk ? <CheckCircle2 size={12} className="text-emerald-400" /> : <AlertTriangle size={12} className="text-amber-400" />) : <AlertTriangle size={12} className="text-slate-500" />}
            Last run: {last ? `${last.status.replace(/_/g, ' ')} · ${fmt(last.finished_at || last.started_at)} (${last.trigger})` : 'no runs recorded yet'}
          </p>
          <p>Schedule: {po.schedule} · cron secret {po.cron_secret_configured ? 'configured' : <span className="text-red-400">MISSING</span>}</p>
          <p>Records: {Object.entries(po.record_status_counts || {}).map(([k, v]) => `${v} ${k}`).join(' · ') || 'none'} · runs with failures: {po.jobs_with_failures}</p>
        </Tile>
      </div>
    </div>
  );
};

export default AdminOverview;
